<template>
  <div class="page-container">
    <searchable-grid title="Offices" :column-defs="columnDefs" :get-rows-promise="getRows"
      @cellDoubleClicked="onCellDoubleClicked">
      <template slot="actions">
        <el-button style="margin-right: 9px" type="primary" icon="fa fa-plus" @click="createOfficeDialogVisible = true"
          v-if="isAdmin">Create Office</el-button>
        <el-button v-loading="syncing" type="primary" icon="fa fa-sync-alt" @click="syncWithZoho" v-if="isAdmin">Sync
          with Zoho</el-button>
      </template>
    </searchable-grid>
    <el-dialog title="Create Office" :visible.sync="createOfficeDialogVisible" width="600px">
      <edit-office-dialog @close="createOfficeDialogVisible = false" @officeUpdated="onOfficeCreated" />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '@/api';
import SearchableGrid from '@/components/grid/SearchableGrid.vue';
import EditOfficeDialog from '@/components/dialog-content/EditOffice.vue';

export default {
  components: {
    EditOfficeDialog,
    SearchableGrid,
  },
  data() {
    return {
      createOfficeDialogVisible: false,
      syncing: false,
      columnDefs: [
        {
          headerName: '#',
          width: 50,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          pinned: true,
        },
        {
          headerName: 'Store No.',
          field: 'storeNum',
          cellRenderer: (params) => {
            if (params.value !== undefined) {
              return params.value;
            }
            return '<i class="el-icon-loading"></i>';
          },
        },
        {
          headerName: 'User Id',
          field: 'userId',
        },
        {
          headerName: 'EFIN',
          field: 'efin',
        },
        {
          headerName: 'Address',
          field: 'address',
        },
        {
          headerName: 'City',
          field: 'city',
        },
        {
          headerName: 'State',
          field: 'state',
        },
        {
          headerName: 'Zip',
          field: 'zip',
        },
        {
          headerName: 'Phone',
          field: 'phone',
        },
        {
          headerName: 'RAF Cash',
          field: 'rafAmount',
          filter: 'number',
        },
        {
          headerName: 'Early Bird Cash',
          field: 'ppmAmount',
          filter: 'number',
        },
      ],
    };
  },
  methods: {
    getRows(params) {
      return api.office.getGridData(params);
    },
    onCellDoubleClicked(event) {
      if (event.data && event.data.id) {
        this.$router.push({ name: 'officeDetail', params: { officeId: event.data.id } });
      }
    },
    onOfficeCreated(office) {
      this.$router.push({ name: 'officeDetail', params: { officeId: office.id } });
    },
    async syncWithZoho() {
      this.syncing = true;
      try {
        await api.office.syncWithZoho();
      } finally {
        this.syncing = false;
      }
    },
  },
  computed: {
    ...mapGetters('User', [
      'isAdmin',
    ]),
  },
};

</script>

<style lang="scss" scoped>
</style>
